export const RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLL = {
  url: 'v2/customer-campaign/enrollments/search?',
  method: 'GET',
  auth: true,
  search: true,
};

export const RQ_CUSTOMER_CAMPAIGN_ENROLL = {
  url: 'v2/customer-campaign/',
  method: 'POST',
  auth: true,
};

export const RQ_UPDATE_CUSTOMER_CAMPAIGN_ENROLL = {
  url: 'v2/customer-campaign/',
  method: 'PUT',
  auth: true,
};

export const RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT = {
  url: 'v2/customer-campaign/search?',
  method: 'GET',
  auth: true,
  search: true,
};

export const RQ_APPROVE_REJECT_CUSTOMER_CAMPAIGN_ENROLLMENT = {
  url: 'v2/customer-campaign/approve-reject/<%= id %>/<%= approver %>/<%= action %>',
  method: 'PUT',
  auth: true,
};

export const RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT_DOCUMENTS = {
  url: 'v2/customer-campaign/documents/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT_DOCUMENTS_LIST = {
  url: 'v2/customer-campaign/document-list/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_CUSTOMER_KYC_DOCUMENT = {
  url: 'v2/customer-kyc/documents/by-customer/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_CUSTOMER_KYC_BY_ID = {
  url: 'v2/customer-kyc/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_CUSTOMER_KYC_BY_CUSTOMER_ID = {
  url: 'v2/customer-kyc/by-customer/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_UPDATE_CUSTOMER_PAN_NO = {
  url: 'v2/customer-kyc/update-pan',
  method: 'PUT',
  auth: true,
};

export const RQ_REJECT_CUSTOMER_KYC = {
  url: 'v2/customer-kyc/reject',
  method: 'PUT',
  auth: true,
};

export const RQ_GET_ENROLLMENT_BY_ID = {
  url: 'v2/customer-campaign/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_SEARCH_CUSTOMER_CAMPAIGN_MASTER = {
  url: 'v2/customer-campaign/master-report?',
  method: 'GET',
  auth: true,
  search: true,
};

export const RQ_EXTEND_CUSTOMER_CAMPAIGN_ENROLL = {
  url: 'v2/customer-campaign/extend/<%= locationId %>/<%= yearMonth %>',
  method: 'PUT',
  auth: true,
};

export const RQ_EXTEND_SINGLE_CUSTOMER_CAMPAIGN_ENROLL = {
  url: 'v2/customer-campaign/extend/<%= enrollmentId %>',
  method: 'PUT',
  auth: true,
};
